import { Box, Tabs, Tab } from '@mui/material'
import { useState } from 'react'
import { PartyBusiness } from './partyBusiness'
import { BranchBusiness } from './branchBusiness'
import { OverallBusiness } from './overAllBusiness'
import useToken from '../../helpers/useTokens'
import UserwiseBusiness from './userwiseBusiness'


const tabsList = [
  { id: 1, name: 'Party Business' },
  { id: 2, name: 'Branch Business' },
  { id: 3, name: 'Userwise Business' },
  { id: 4, name: 'Overall Booking' },
]
export const headColor = {
  header: '#bfe1ff',
  header2: '#e5f3ff',
  subHeader: '#daedfe',
  total: '#eeeeee',
  entry: '#ffffff',
}
export const BusinessAnalysis = () => {
  const {loginData} = useToken()
  const isAdmin = loginData?.IsAdmin || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin
  const TabList = isAdmin ? tabsList : tabsList.filter((tab) => tab.id !== 1)

  const [selectedTab, setSelectedTab] = useState(TabList[0].id)
  
  return (
    <Box>
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" aria-label="bsic tabs example">
        {TabList.map((tab) => (
          <Tab
            key={`tabbusiness_${tab.id}`}
            value={tab.id}
            label={tab.name}
            sx={{
              fontSize: '1rem',
              height: '40px',
              minHeight: '40px',
              fontSize: '12px',
              fontWeight: '600',
            }}
          />
        ))}
      </Tabs>
      {selectedTab === 1 && <PartyBusiness />}
      {selectedTab === 2 && <BranchBusiness />}
      {selectedTab === 3 && <UserwiseBusiness />}
      {selectedTab === 4 && <OverallBusiness />}
    </Box>
  )
}
